//import ListQnA from "./ListQnA";
import React from "react";
import questions from "./qnaJSONdata/QnAReact.json";
import QnASideBarRight from "./QnASideBarRight";
import ScrollButton from "../../ScrollButton";

const QnAReact = () => {
  return (
    <div className="container-fluid">
      <div className="row flex-xl-nowrap">
        <div className="col-6 col-md-2 clo-xl-2 bd-sidebar mb-2 m4"></div>
        <main
          className="col-12 col-md-9 col-xl-8 py-md-3 pl-md-5 bd-content"
          role="main"
        >
          <div className="col-xs-12">
            <h2>
              Top 60 React JS Interview Questions and Answers: Ace Your Next
              React Job Interview!
            </h2>
            <p className="text-left lead text-justify text-break">
              React JS is an open-source JavaScript library widely used for
              building complex and interactive user interfaces (UIs). It is
              known for its fast rendering performance, reusable components, and
              straightforward syntax, making it a top choice for web developers
              worldwide. With React, you can create dynamic web applications
              that offer seamless user experiences, helping to enhance your
              website's engagement and overall success.
            </p>

            <p className="text-left lead text-justify text-break">
              <ol>
                {questions.map(question => (
                  <li key={question.id}>
                    <h5>{question.question}</h5>
                    <div>
                      <p>{question.answer}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </p>
          </div>
        </main>
        <div className="col-6 col-md-2 clo-xl-2 mb-2 border-left">
          <QnASideBarRight />
        </div>
      </div>
      <ScrollButton />
    </div>
  );
};

export default QnAReact;
